import Vue from 'vue';
import Vuex from 'vuex';
import user from "@/store/modules/user";
import twoFactor from "@/store/modules/twoFactor";

Vue.use(Vuex);

export default new Vuex.Store({
    modules: {
        user,
        twoFactor
    }
})